<template>
<div class="flex-container" id="ql-login-screen">
    <md-layout md-vertical-align="center">
        <md-layout md-flex="30" md-flex-offset="35" md-align="center">
            <h1>
                <img :src="require('../assets/img/cuelistBLACK.png')" alt="LOGO"/>
            </h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center">
            <md-button class="md-raised md-primary" @click="login" v-if="signingIn"><md-icon>person</md-icon>&nbsp;Sign in with Google</md-button>
            <md-button class="md-raised md-primary" @click="login" v-else><md-icon>person</md-icon>&nbsp;Register with Google</md-button>
        </md-layout>
        <md-layout md-flex="30" md-flex-offset="35" md-align="center">
            <h1 class="md-body-1">Or</h1>
            <md-layout md-flex="100" md-align="center" v-if="signingIn">
                <h1 class="md-title">Sign in with your email</h1>
                <login-form />
                <md-button @click="toggleRegister">Need to Register instead?</md-button>
            </md-layout>
            <md-layout md-flex="100" md-align="center" v-else>
                <h1 class="md-title">Register with your email</h1>
                <register-form @success="createUser" />
                <md-button @click="toggleRegister">Need to Sign In instead?</md-button>
            </md-layout>
        </md-layout>
    </md-layout>
    <core-footer/>
</div>
</template>

<script>
import firebase from 'firebase';

import CoreFooter from '@/components/core/footer';
import AuthLoginForm from '@/components/auth/login-form';
import AuthRegisterForm from '@/components/auth/register-form';

const LoginView = {
    name: 'LoginView',
    data: function() {
        return {
            signingIn: true
        };
    },
    props: ['redirect'],
    methods: {
        login() {
            const self = this;
            const provider = new firebase.auth.GoogleAuthProvider();

            firebase.auth().signInWithPopup(provider).then((res) => {
                const user = res.user;
                user.signInMethod = 'google';
                this.createUser(user).then(() => {
                    const redirect = self.$route.query.redirect || '/dashboard';
                    self.$router.replace(redirect);
                });
            });
        },
        createUser(user) {
            const now = new Date();
            const newUser = {
                username: user.displayName,
                email: user.email,
                profile_picture: user.photoURL,
                uid: user.uid,
                last_login: now.toISOString(),
                active_pay: false,
                subscription_level: 0,
                signInMethod: user.signInMethod
            };

            const usersRef = firebase.database().ref('users');
            return usersRef.child(user.uid).transaction((currentUserData) => {
                // Check if user data exists; If not, create user.
                if (currentUserData === null) {
                    return newUser;
                }
                
                currentUserData.email = user.email;
                currentUserData.uid = user.uid;
                currentUserData.signInMethod = user.signInMethod;
                currentUserData.username = user.displayName;
                currentUserData.profile_picture = user.photoURL;
                currentUserData.last_login = now.toISOString();
                return currentUserData;
            }, (error, committed) => {
                if (error) {
                    console.log('Transaction failed abnormally!', error);
                }
                return committed;
            });
        },
        toggleRegister() {
            this.signingIn = !this.signingIn;
        }
    },
    components: {
        'core-footer': CoreFooter,
        'login-form': AuthLoginForm,
        'register-form': AuthRegisterForm
    }
};
export default LoginView;
</script>

<style lang="scss">
/*#ql-login-screen {
    background-color: #0d2744;
    color: #FFF;
}

#ql-login-screen .md-input-container, #ql-login-screen label,
#ql-login-screen .md-input-container.md-has-value input,
#ql-login-screen .md-input-container.md-input-focused input{
    color: #FFF !important;
}*/
</style>


// WEBPACK FOOTER //
// login.vue?a4a62fe4